import React, { Component } from 'react';
import { Accordian } from './Accordian'
class FAQ extends Component {
    render() {
        return (
            <div className="settings-container flex-column max-width">
                <div id="settings-content-container" className="flex-centered max-size">
                    <div className="flex-column-center shadow" id="settings-content">
                        <h3 className="faq-header">Frequently Asked Questions</h3>
                        <Accordian />
                    </div>
                </div>
            </div>
        )
    }
}

export default FAQ